import { render, staticRenderFns } from "./nutritionM.vue?vue&type=template&id=4210b1c3"
import script from "./nutritionM.vue?vue&type=script&lang=js"
export * from "./nutritionM.vue?vue&type=script&lang=js"
import style0 from "./nutritionM.vue?vue&type=style&index=0&id=4210b1c3&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports